module.exports = __webpack_public_path__ + "static/media/logo_bonaldo.a5efbaa4.svg";